export default __webpack_public_path__ + "static/media/add-file-icon.2a41f5bb.svg";